import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert,
  TextField, MenuItem, Box,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const RAZONES = ["Vacación", "Permiso"];
const isoFecha = (value) => (value ? String(value).slice(0, 10) : "");

const EditarSolicitudDialog = ({ open, onClose, solicitud, onGuardado }) => {
  const [form, setForm] = useState({ razon: "", fecha_ini: "", fecha_fin: "", dias: "", observacion: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && solicitud) {
      setForm({
        razon: solicitud.razon || "Vacación",
        fecha_ini: isoFecha(solicitud.fecha_ini),
        fecha_fin: isoFecha(solicitud.fecha_fin),
        dias: String(solicitud.dias ?? ""),
        observacion: solicitud.observacion || "",
      });
      setError("");
    }
  }, [open, solicitud]);

  const handleChange = (campo) => (e) => setForm((prev) => ({ ...prev, [campo]: e.target.value }));

  const puedeGuardar = form.razon && form.fecha_ini && form.fecha_fin && Number(form.dias) > 0 && !saving;

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.patch(`/api/permisos/${solicitud.id}`, {
        razon: form.razon,
        fecha_ini: form.fecha_ini,
        fecha_fin: form.fecha_fin,
        dias: Number(form.dias),
        observacion: form.observacion.trim(),
      });
      onGuardado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al guardar los cambios.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Editar solicitud #{solicitud?.id}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField select size="small" label="Razón" value={form.razon} onChange={handleChange("razon")}>
            {RAZONES.map((r) => <MenuItem key={r} value={r}>{r}</MenuItem>)}
          </TextField>
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
            <TextField
              size="small" type="date" label="Fecha inicio" InputLabelProps={{ shrink: true }}
              value={form.fecha_ini} onChange={handleChange("fecha_ini")}
            />
            <TextField
              size="small" type="date" label="Fecha fin" InputLabelProps={{ shrink: true }}
              value={form.fecha_fin} onChange={handleChange("fecha_fin")}
            />
          </Box>
          <TextField
            size="small" label="Cantidad de días" value={form.dias}
            inputProps={{ inputMode: "decimal" }}
            onChange={(e) => {
              const v = e.target.value.replace(",", ".");
              if (/^\d*\.?\d*$/.test(v)) setForm((prev) => ({ ...prev, dias: v }));
            }}
          />
          <TextField
            size="small" label="Observación" multiline minRows={2}
            value={form.observacion} onChange={handleChange("observacion")}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar}>
          {saving ? "Guardando..." : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarSolicitudDialog;
